export {DefaultMasterPageComponent} from './default-master/default-master.component';
export {LoginPageComponent} from './login/login.component';
export {ForgotPasswordPageComponent} from './forgot-password/forgot-password.component';
export {ChangePasswordPageComponent} from './change-password/change-password.component';
export {TravelsPageComponent} from './travels/travels.component';
export {TravelProfileComponent} from './travel-profile/travel-profile.component';
export {EventsPageComponent} from './events/events.component';
export {MainPageComponent} from './main/main.component';
export {ChatPageComponent} from './chat/chat.component';

export {UserProfileComponent} from './user-profile/user-profile.component';
